module.exports = __webpack_public_path__ + "img/icon113.780c5128.png";